import AbstractPersistence from "./AbstractPersistence"

const SessionStoragePersistence = Object.create(AbstractPersistence)

SessionStoragePersistence.storage = window.sessionStorage

export default SessionStoragePersistence
